module.exports = "/_next/static/images/36-1-8696b207a00ef4aabc0d6fcd46980315.jpg";